import { MeasureController } from "../../MeasureController";
import { JudgmentResult, JudgmentResultType } from "../../types.client";
import { DcVoltageMeasure } from "../../../models/schemas/measures/electrical.schema";
import { DC_VOLTAGE_THRESHOLDS } from "../../constants/judgmentCriteria";

/**
 * DC 입력 전압 컨트롤러
 * 판정 기준: |측정전압 - 정격전압| <= 정격전압 * DC_VOLTAGE_THRESHOLDS.tolerance (±2%)
 */
export class DcVoltageController extends MeasureController<DcVoltageMeasure> {
  protected getDefaultData(): DcVoltageMeasure {
    return {
      ratedVoltage: 0,
      measuredVoltage: 0,
      result: null,
      discussion: "",
      remark: "",
      photo: { checkUrl: "", resultUrl: "" },
    };
  }

  protected judge(): JudgmentResult {
    const { ratedVoltage, measuredVoltage } = this.data;

    // 데이터 미입력 시
    if (!ratedVoltage || !measuredVoltage) {
      return {
        result: "NA",
        discussion: this.generateDiscussion("NA"),
      };
    }

    // 판정: |측정전압 - 정격전압| <= 정격전압 * DC_VOLTAGE_THRESHOLDS.tolerance (±2%)
    const tolerance = ratedVoltage * DC_VOLTAGE_THRESHOLDS.tolerance;
    const deviation = Math.abs(measuredVoltage - ratedVoltage);
    const result: JudgmentResultType = deviation <= tolerance ? "GOOD" : "BAD";

    return {
      result,
      discussion: this.generateDiscussion(result),
    };
  }

  protected generateDiscussion(result: JudgmentResultType): string {
    if (result === "NA") {
      return "데이터 미입력";
    }
    if (result === "GOOD") {
      return "DC 입력 전압이 정격 전압 대비 ±2% 이내로 정상";
    }
    return "DC 입력 전압이 정격 전압 대비 ±2% 범위를 벗어남. 점검 필요";
  }
}
